import { useEffect } from 'react';

import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import logo from '../images/class-logo-full-color-rgb-313px@72ppi.png';
import { type OauthState } from '../utils/oauthState';

const StyledHeader = styled.div`
    margin: 10px;
    display: flex;
    align-items: flex-end;
`;

const StyledLogo = styled.img`
    width: 151px;
`;

const StyledTitle = styled(Typography)`
    margin-left: 26px;

    font-family: Lato;
    font-size: 20px;
    font-style: normal;
    font-weight: bold;
    letter-spacing: 0.15000000596046448px;
    text-align: left;
`;

const StyledMainDiv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const StyledTextDiv = styled.div`
    flex: 1;
    margin-top: 40px;
`;

const StyledIncorrectDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const InfoTextGroupDiv = styled.div`
    text-align: center;
    margin: auto;
`;

const StyledEmailsDiv = styled.div`
    margin: 20px auto 0px auto;
    background-color: ${(props) => props.theme.colors.gray};
    border-radius: 8px;
    padding: 9px 26px;
`;

const StyledEmailTitle = styled(Typography)`
    text-align: right;
    font-weight: 500;
`;

const StyledEmailText = styled(Typography)`
    font-weight: 500;
`;

const MicrosoftAuthSuccess = () => {
    const { ready, t } = useTranslation('microsoft_auth');

    const search = new URLSearchParams(window.location.search);
    const state = JSON.parse(search.get('state') ?? '{}') as OauthState;
    const lmsEmail = state.email ?? 'no-lms-email';
    const ssoEmail = search.get('email') ?? 'no-sso-email';
    const correctEmail = lmsEmail.toLowerCase() === ssoEmail.toLowerCase();

    useEffect(() => {
        const opener: Window = window.opener;
        if (!opener) {
            console.error('No opener window');
            return;
        }

        const origin = opener.location.origin;
        const msg = { success: correctEmail };
        console.info('Sending message to', origin, msg);
        opener.postMessage(msg, origin);
    }, [correctEmail]);

    const CorrectEmail = () => (
        <StyledMainDiv>
            <StyledTextDiv>
                <Typography variant="h1">{t('success')}</Typography>
            </StyledTextDiv>
            <Typography>{t('return-to-lms')}</Typography>
        </StyledMainDiv>
    );

    const IncorrectEmail = () => (
        <StyledIncorrectDiv>
            <InfoTextGroupDiv>
                <Typography variant="h1" align="center">
                    {t('incorrect-login')}
                </Typography>
                <Typography align="center">{t('email-issue-error')}</Typography>
            </InfoTextGroupDiv>
            <StyledEmailsDiv>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <StyledEmailTitle>{t('expected-email')}:</StyledEmailTitle>
                    </Grid>
                    <Grid item xs={6}>
                        <StyledEmailText>{lmsEmail}</StyledEmailText>
                    </Grid>
                    <Grid item xs={6}>
                        <StyledEmailTitle>{t('sso-email')}:</StyledEmailTitle>
                    </Grid>
                    <Grid item xs={6}>
                        <StyledEmailText>{ssoEmail}</StyledEmailText>
                    </Grid>
                </Grid>
            </StyledEmailsDiv>
        </StyledIncorrectDiv>
    );

    if (ready) {
        return (
            <>
                <StyledHeader>
                    <StyledLogo src={logo} />
                    <StyledTitle>{search.get('title')}</StyledTitle>
                </StyledHeader>

                {correctEmail ? <CorrectEmail /> : <IncorrectEmail />}
            </>
        );
    }

    return null;
};

export default MicrosoftAuthSuccess;
